import { consultarConfiguracoesEditor } from "../prontuario-detail-editor";
import { requisitarLayoutPEP } from "../prontuario-layout";
import { consultarConfiguracoesProntuario } from "../prontuario-configuracoes";
import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {
    fgSistema: JwtService.getSistema(), 
    fgZoomScreen: JwtService.criarObterGenerico("fgZoomScreen", 100), 
    fgTema: JwtService.criarObterGenerico("fgTema", "light"), 
    fgMenuLateralCollapse: JwtService.criarObterGenerico("fgMenuLateralCollapse", false), 
    camposHorariosDefault: [{
        id: "_ordemdoscamposboard", 
        title: "Ordem dos Campos", 
        class: "bg-light-primary", 
        item: [{
            id: "MEDICO", 
            title: "Médico"
        }, {
            id: "HORA_CHEGADA", 
            title: "Hora Chegada"
        }, {
            id: "HORA", 
            title: "Hora"
        }, {
            id: "PACIENTE_FOTO", 
            title: "Paciente Foto"
        }, {
            id: "PACIENTE", 
            title: "Paciente"
        }, {
            id: "CONVENIO", 
            title: "Plano de Saúde"
        }, {
            id: "STATUS", 
            title: "Status"
        }, {
            id: "LOCAL", 
            title: "Local/Obs.Local"
        }, {
            id: "ACOES", 
            title: "Ações"
        }, {
            id: "TV", 
            title: "Chamar"
        }, {
            id: "PROCEDIMENTO", 
            title: "Procedimentos"
        }, {
            id: "NOTAS", 
            title: "Notas"
        }, {
            id: "UNIDADE", 
            title: "Unidade"
        }]
    }, {
        id: "_ocultarcamposboard", 
        title: "Ocultar Campos", 
        class: "bg-light-primary", 
        item: []
    }], 
    statusMonocolor: "0",
    agendaVisualPronta: false,
    agendaVisualErro: false,
    camposHorarios: []
};

const getters = {
    camposHorariosDefault: state => state.camposHorariosDefault,
    statusMonocolor: state => state.statusMonocolor,
    agendaVisualPronta: state => state.agendaVisualPronta,
    agendaVisualErro: state => state.agendaVisualErro,
    fgSistema(state) {
        return state.fgSistema;
    },
    fgZoomScreen(state) {
        return state.fgZoomScreen;
    },
    fgTema(state) {
        return state.fgTema;
    },
    fgMenuLateralCollapse(state) {
        return state.fgMenuLateralCollapse;
    }, 
    camposHorarios(state) {
        return state.camposHorarios;
    }
};

const mutations = {
    updateAgendaVisual(store, dados) { Object.assign(store, dados); },
    updatefgZoomScreen(store, zoom) {
        store.fgZoomScreen = zoom;
        JwtService.salvarGenerico("fgZoomScreen", zoom);
    },
    updatefgTema(store, tema) {
        store.fgTema = tema;
        JwtService.salvarGenerico("fgTema", tema);
    },
    updatefgMenuLateralCollapse(store, menuLateralCollapse) {
        store.fgMenuLateralCollapse = menuLateralCollapse;
        JwtService.salvarGenerico("fgMenuLateralCollapse", menuLateralCollapse);
    }, 
    updatefgSistema(store, sistema) {
        store.fgSistema = sistema;
        JwtService.saveSistema(sistema);
    }, 
    updateCamposHorarios(store, boardsFormatados) {
        let acheiOcultos = false;

        boardsFormatados.forEach((board) => {
            if(board.id === "_ocultarcamposboard") {
                acheiOcultos = true;
            }
        });

        if(!acheiOcultos) {
            boardsFormatados.push({
                id: "_ocultarcamposboard", 
                title: "Ocultar Campos", 
                class: "bg-light-primary", 
                item: []
            });
        }

        store.camposHorariosDefault.flatMap(board => board.item).forEach((campoDefault) => {
            let acheiCampo = false;

            boardsFormatados.forEach((board) => {
                board.item.forEach((campo) => {
                    if(campo.id === campoDefault.id) {
                        acheiCampo = true;
                    }
                });
            });

            if(!acheiCampo) {
                boardsFormatados.forEach((board) => {
                    if(board.id === "_ocultarcamposboard") {
                        board.item.push({ ...campoDefault });
                    }
                });
            }
        });

        store.camposHorarios = boardsFormatados;
    }, 
    updateCamposHorariosDefault(store) {
        store.camposHorarios = JSON.parse(JSON.stringify(store.camposHorariosDefault));
    }
};

let agendaVisualPedido;
const actions = {
    requisitarLayoutPEP(context, dados) { return requisitarLayoutPEP(ApiService, JwtService, dados); },
    getConfiguracaoMaster(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("configuracoes/access/buscarConfiguracaoMaster", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getConfiguracaoMasterUsuario(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("configuracoes/access/buscarConfiguracaoMasterUsuario", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    consultarConfiguracoesFichaHistorico(context, dados) {
        return consultarConfiguracoesEditor(ApiService, JwtService, dados);
    },
    consultarConfiguracoesProntuario(context, dados) {
        return consultarConfiguracoesProntuario(ApiService, JwtService, dados);
    },
    getConfiguracoesMasterMultiplas(context, dados) {
        return new Promise((resolve, reject) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("configuracoes/access/buscarConfiguracoesMasterMultiplas", dados).then(({ data }) => {
                    resolve(data);
                }).catch(reject);
            } else reject(new Error("Sessão indisponível."));
        });
    }, 
    getConfiguracoesGerais() {
        return new Promise((resolve, reject) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("configuracoes/access/buscarConfiguracoesGerais").then(({ data }) => {
                    resolve(data);
                }).catch(reject);
            } else reject(new Error("Sessão indisponível."));
        });
    }, 
    getConfiguracoesGeraisUsuario() {
        return new Promise((resolve, reject) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("configuracoes/access/buscarConfiguracoesGeraisUsuario").then(({ data }) => {
                    resolve(data);
                }).catch(reject);
            } else reject(new Error("Sessão indisponível."));
        });
    }, 
    getConfiguracoesWhatsApp() {
        return new Promise((resolve, reject) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("configuracoes/access/buscarWhatsAppTodas").then(({ data }) => {
                    resolve(data);
                }).catch(reject);
            } else reject(new Error('Sessão indisponível.'));
        });
    }, 
    getConfiguracaoCamposHorarios({ commit }) {
        const token = JwtService.getToken();
        if(agendaVisualPedido?.token === token) { return agendaVisualPedido.promise; }
        commit("updateAgendaVisual", { agendaVisualPronta: false, agendaVisualErro: false });
        const pedido = { token }; agendaVisualPedido = pedido;
        pedido.promise = (async () => {
            try {
                if(!token) { throw new Error("Sessão indisponível."); }
                ApiService.setHeader();
                const [colunas, cores] = await Promise.all([
                    ApiService.postOnce("configuracoes/access/buscarConfiguracaoMasterUsuario", {
                        CONTEUDO_NOME: "TEXTO", NIVEL: "4", OPERACAO: "C", SISTEMA: "CLMADV",
                        MODULO: "AGENDA", CAMPO: "ORDEM_CAMPOS_HORARIOS", CONTEUDO: ""
                    }, { timeout: 30000 }),
                    ApiService.postOnce("configuracoes/access/buscarConfiguracaoMaster", {
                        CONTEUDO_NOME: "CONTEUDO", NIVEL: "2", OPERACAO: "C", USUARIO: "GERAL", SISTEMA: "CLMADV",
                        MODULO: "AGENDA", CAMPO: "STATUS_AGENDA_MONOCOLOR", CONTEUDO: "0"
                    }, { timeout: 30000 })
                ]);
                if(agendaVisualPedido !== pedido || JwtService.getToken() !== token) { return false; }
                if(!colunas.data || !cores.data || typeof colunas.data !== "object" || typeof cores.data !== "object" ||
                    colunas.data.error || cores.data.error || colunas.data.resultado === false || cores.data.resultado === false ||
                    Array.isArray(colunas.data) || Array.isArray(cores.data)) { throw new Error("Configuração indisponível."); }
                const boards = colunas.data.TEXTO ? JSON.parse(colunas.data.TEXTO) : null;
                if(boards && !Array.isArray(boards)) { throw new Error("Colunas inválidas."); }
                if(boards) { commit("updateCamposHorarios", boards); } else { commit("updateCamposHorariosDefault"); }
                commit("updateAgendaVisual", { statusMonocolor: String(cores.data.CONTEUDO || "0"), agendaVisualPronta: true, agendaVisualErro: false });
                return true;
            } catch(error) {
                if(agendaVisualPedido === pedido && JwtService.getToken() === token) { commit("updateAgendaVisual", { agendaVisualPronta: false, agendaVisualErro: true }); }
                return false;
            } finally { if(agendaVisualPedido === pedido) { agendaVisualPedido = null; } }
        })();
        return pedido.promise;
    },
    salvarConfiguracoesWhatsAppVarias(context, dados) {
        return new Promise((resolve, reject) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("configuracoes/access/salvarVariasWhatsApp", dados).then(({ data }) => {
                    resolve(data);
                }).catch(reject);
            } else reject(new Error('Sessão indisponível.'));
        });
    }, 
    getConfiguracoesAgentesIA() {
        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("configuracoes/access/buscarAgenteIATodas").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    salvarConfiguracoesAgentesIAVarias(context, dados) {
        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("configuracoes/access/salvarVariasAgentesIA", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    salvarConfiguracoesGerais(context, dados) {
        return new Promise((resolve, reject) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("configuracoes/access/salvarConfiguracoesGerais", dados).then(({ data }) => {
                    resolve(data);
                }).catch(reject);
            } else reject(new Error("Sessão indisponível."));
        });
    }, 
    salvarConfiguracoesGeraisUsuario(context, dados) {
        return new Promise((resolve, reject) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("configuracoes/access/salvarConfiguracoesGeraisUsuario", dados).then(({ data }) => {
                    resolve(data);
                }).catch(reject);
            } else reject(new Error("Sessão indisponível."));
        });
    },
    updatefgZoomScreen({ commit }, zoom) {
        commit('updatefgZoomScreen', zoom);
    }, 
    updatefgTema({ commit }, tema) {
        commit('updatefgTema', tema);
    }, 
    updatefgMenuLateralCollapse({ commit }, menuLateralCollapse) {
        commit('updatefgMenuLateralCollapse', menuLateralCollapse);
    }, 
    updatefgSistema({ commit }, sistema) {
        commit('updatefgSistema', sistema);
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
